import { useCallback, useEffect, useState } from "react";
import { GenieAcsService } from "../services/GenieAcsService";

export const useHookGenieAcs = () => {
    const [data, setData] = useState([]);
    const [meta, setMeta] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [keyword, setKeyword] = useState("");
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [sort, setSort] = useState("asc");
    const [order, setOrder] = useState("name");


    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await GenieAcsService.get({search: keyword, page, limit, sort, order});

            const result = res?.data?.data ?? [];

            setData(Array.isArray(result) ? result : []);
            setMeta(res?.data?.meta);
        } catch (err) {
            console.error(err);
            setError(err?.response?.data || err);
        } finally {
            setLoading(false);
        }
    }, [keyword, page, limit, sort, order, ]);

    useEffect(() => {
        getData();
    }, [getData]);

    return {
        data,
        meta,
        loading,
        error,

        keyword, setKeyword,
        page, setPage,
        limit, setLimit,
        sort, setSort,
        order, setOrder,

        refreshData: getData,
    };
};